import * as React from "react";

import { BaseTile } from "Components/BaseTile";
import { CoopBenefits } from "Components/Partner/CoopBenefits/CoopBenefits";
import { useABTestingFeature } from "Utils/unleash/flagHooks";
import { FeatureFlagABTest } from "Utils/unleash/flags";
import { LoginWithRegisteredVehicles } from "./LoginWithRegisteredVehicles";
import { LoginWithoutRegisteredVehicles } from "./LoginWithoutRegisteredVehicles";

export const CarLogin = (): React.ReactElement => {
  const loginOnlyBankId = useABTestingFeature(
    FeatureFlagABTest.SSX_1950_LOGIN_ONLY_BANKID,
  );

  return (
    <BaseTile>
      <LoginWithRegisteredVehicles loginOnlyBankId={loginOnlyBankId} />
      {!loginOnlyBankId && <LoginWithoutRegisteredVehicles />}
      <CoopBenefits />
    </BaseTile>
  );
};
